import React from 'react'

function VnFlag({ className, onClick }) {
    return (
        <svg onClick={onClick} className={className} width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_8_702)">
                <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#D80027" />
                <path d="M10 5.21738L11.0792 8.53882H14.5716L11.7462 10.5916L12.8254 13.913L10 11.8603L7.17461 13.913L8.25383 10.5916L5.42844 8.53882H8.92078L10 5.21738Z" fill="#FFDA44" />
            </g>
            <defs>
                <clipPath id="clip0_8_702">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}

export default VnFlag